import type { SmsReportExportRequest } from '@/types/reports';
import { ApiService } from './api.service';

const SMS_EXPORT_URL = '/api/v1/reports/sms/export';

class ReportsService extends ApiService {
  public async exportSmsReport(payload: SmsReportExportRequest): Promise<Blob> {
    return this.postBlob(SMS_EXPORT_URL, payload);
  }
}

export const reportsService = new ReportsService();
